import React from 'react';
import styled from '@emotion/styled';

const Wrapper = styled('div')`
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;
  &.show {
    display: block;
  }
  .spinner-border {
    position: absolute;
    top: calc(50% - 16px);
    left: calc(50% - 16px);
  }
`;

const SpinnerBlock = (props) => {
  const { show, whiteMode, style = {} } = props;
  return (
    <Wrapper
      className={`spinner-block ${show ? 'show' : ''}`}
      data-testid="spinner-wrap"
      style={{
        backgroundColor: whiteMode ? `white` : `initial`,
        ...style,
      }}
    >
      <div className="spinner-border text-info" role="status"></div>
    </Wrapper>
  );
};

export default SpinnerBlock;
